export default __webpack_public_path__ + "static/media/pdf-icon.a95b1551.svg";